
    <div #chartContainer id="chart_div_{{this.PlayerId()}}" class="chart-container">

    </div>
